import { render } from "./gsrsu04020301.vue?vue&type=template&id=97b5fec6&scoped=true"
import script from "./gsrsu04020301.vue?vue&type=script&lang=js"
export * from "./gsrsu04020301.vue?vue&type=script&lang=js"

import "./gsrsu04020301.vue?vue&type=style&index=0&id=97b5fec6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97b5fec6"]])

export default __exports__